import { Component, Inject } from '@angular/core'
import { EditProfile, Profile } from '../../models/users.interface'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ToastrService } from 'ngx-toastr'
import {
    AbstractControl,
    FormBuilder,
    FormsModule,
    ReactiveFormsModule,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms'
import { ProfileService } from '../../services/profile/profile.service'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { NgIf } from '@angular/common'
import { MatIcon } from '@angular/material/icon'

@Component({
    selector: 'app-edit-password',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        NgIf,
        MatError,
        MatIcon,
    ],
    templateUrl: './edit-password.component.html',
    styleUrl: './edit-password.component.css',
})
export class EditPasswordComponent {
    selectedProfile: Profile | null = null
    showPasswordMatchError = false

    constructor(
        private dialogRef: MatDialogRef<EditPasswordComponent>,
        private toastr: ToastrService,
        private fb: FormBuilder,
        private profileService: ProfileService,
        @Inject(MAT_DIALOG_DATA) public data: { selectedProfile: Profile }
    ) {}

    ngOnInit(): void {
        this.selectedProfile = this.data.selectedProfile
    }

    closeDialog() {
        this.dialogRef.close()
    }

    matchPassword: ValidatorFn = (
        group: AbstractControl
    ): ValidationErrors | null => {
        let pass = group.get('password')?.value
        let confirmPass = group.get('confirmPassword')?.value
        return pass === confirmPass ? null : { notSame: true }
    }

    editPasswordForm = this.fb.group(
        {
            password: ['', [Validators.required, Validators.minLength(4)]],
            confirmPassword: [
                '',
                [Validators.required, Validators.minLength(4)],
            ],
        },
        { validators: this.matchPassword }
    )

    updatePassword() {
        this.showPasswordMatchError = true
        if (this.selectedProfile) {
            const payload: EditProfile & { id: number } = {
                first_name: this.selectedProfile.first_name,
                last_name: this.selectedProfile.last_name,
                email: this.selectedProfile.email,
                username: this.selectedProfile.username,
                password: this.editPasswordForm.get('password')?.value ?? '',
                confirmPassword:
                    this.editPasswordForm.get('confirmPassword')?.value ?? '',
                id: this.selectedProfile.id,
            }

            if (this.editPasswordForm.status === 'VALID') {
                this.profileService
                    .editPassword(this.selectedProfile.id, payload)
                    .subscribe({
                        next: (profile) => {
                            const msg = `La contraseña fue actualizada correctamente!`
                            this.closeDialog()
                            this.toastr.success(msg, 'Existoso!', {
                                progressBar: true,
                                timeOut: 5000,
                            })
                        },
                    })
            }
        }
    }
}
